import { ChangeDetectionStrategy, Component } from "@angular/core";
import { AuthenticationService } from "app/auth/service";
import { getDateOffset } from "app/main/helpers/time";

@Component({
  selector: "app-tz-details",
  templateUrl: "./tz-details.component.html",
  styleUrls: ["./tz-details.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TzDetailsComponent {
  browser: { tz: string; offset: string } = null;
  company: { tz: string; offset: string } = null;

  constructor(private readonly authService: AuthenticationService) {
    this.refreshDetails();
  }

  refreshDetails = () => {
    this.company = {
      offset: getDateOffset(this.authService.companyTz),
      tz: this.authService.companyTz,
    };
    this.browser = {
      offset: getDateOffset(),
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  get isSender() {
    return this.authService.isSender || this.authService.isSubAdmin;
  }
}
